import { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import './ConfirmClientCommentForm.scss';


export default function ConfirmClientCommentForm(props) {
    const [cursor] = useState('auto');
    const className = 'confirmClientCommentForm';

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            props?.handleSubmitClientComments();
        }
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: { backgroundColor: 'rgba(0, 0, 0, 0.6)' }
                }
            }}
        >
            <Fade in={props.open}>
                <Box className={className + '__container'}>
                    <Paper className={className + '__paper'} elevation={24}>
                        {/* Header */}
                        <Box className={className + '__header'}>
                            <Box className={className + '__headerContent'}>
                                <Box className={className + '__iconWrapper'}>
                                    <ForumOutlinedIcon className={className + '__headerIcon'} />
                                </Box>
                                <Box>
                                    <Typography className={className + '__title'}>
                                        Send to Client?
                                    </Typography>
                                    <Typography className={className + '__subtitle'}>
                                        This will notify the reporter
                                    </Typography>
                                </Box>
                            </Box>
                            <IconButton
                                onClick={props.closePopup}
                                className={className + '__closeBtn'}
                                size="small"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Divider />

                        {/* Body */}
                        <Box className={className + '__body'}>
                            {/* Warning Box */}
                            <Box className={className + '__warning'}>
                                <WarningAmberRoundedIcon className={className + '__warningIcon'} />
                                <Box className={className + '__warningContent'}>
                                    <Typography className={className + '__warningTitle'}>
                                        This comment will be visible to the reporter
                                    </Typography>
                                    <Typography className={className + '__warningText'}>
                                        They will receive this message on their WhatsApp and in the client portal.
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Comment Preview */}
                            <Box className={className + '__preview'}>
                                <Box className={className + '__previewHeader'}>
                                    <WhatsAppIcon className={className + '__whatsappIcon'} />
                                    <Typography className={className + '__previewLabel'}>
                                        Message Preview
                                    </Typography>
                                </Box>
                                <Box className={className + '__previewContent'}>
                                    <Typography className={className + '__previewText'}>
                                        {props?.commentText}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Divider />

                        {/* Footer */}
                        <Box className={className + '__footer'}>
                            <Button
                                variant="outlined"
                                onClick={props.closePopup}
                                className={className + '__cancelBtn'}
                                disabled={cursor === 'wait'}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={props?.handleSubmitClientComments}
                                disabled={cursor === 'wait'}
                                startIcon={<SendIcon />}
                                className={className + '__submitBtn'}
                                onKeyPress={handleKeyPress}
                            >
                                Send to Client
                            </Button>
                        </Box>
                    </Paper>
                </Box>
            </Fade>
        </Modal>
    );
}
